export function getCharacterCountText(
  value: string | number | string[] | undefined,
  maxCharacterLength: number | undefined
): string | number {
  const displayValue =
    typeof value === 'number' ? value.toString().length : value?.length || 0;
  return maxCharacterLength !== undefined
    ? `${displayValue} / ${maxCharacterLength}`
    : displayValue;
}
